(() => {
  'use strict';
  const root = document.querySelector('[data-monolith-advisors]');
  const directory = document.querySelector('[data-monolith-brand-directory]');
  const field = root?.querySelector('[data-advisor-help-search]');
  const results = root?.querySelector('[data-advisor-help-results]');
  const status = root?.querySelector('[data-advisor-help-search-status]');
  if (!root || !directory || !field || !results || !status) return;
  const normalize = value => String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/ß/g,'ss').replace(/[^\p{L}\p{N}]+/gu,' ').trim();
  const compact = value => normalize(value).replace(/ /g,'');
  let vendors;
  try { vendors = JSON.parse(directory.dataset.vendors); } catch (_) { return; }
  if (!Array.isArray(vendors)) return;
  const brands = [...new Set(vendors.filter(value => typeof value === 'string' && value.trim()))].map(name => {
    const normalized = normalize(name);
    const short = normalized.replace(/(?:\s+(?:cosmetics?|beauty|makeup|make up))+$/,'');
    return {name,aliases:[...new Set([normalized,short])].filter(Boolean)};
  });
  const copy = {
    de:['Alle Produkte','Produkte werden geladen …','Welche Marke meinst du?','Aktuell sind hier keine Produkte dieser Marke verfügbar.','Die Vorschau konnte nicht geladen werden. Über „Alle Produkte“ kommst du zur Marke.','Nochmals laden','Zurzeit ausverkauft','Produkte von'],
    en:['All products','Loading products …','Which brand do you mean?','No products from this brand are currently available here.','The preview could not be loaded. Use “All products” to browse the brand.','Try again','Currently sold out','Products by'],
    fr:['Tous les produits','Chargement des produits …','Quelle marque recherchez-vous ?','Aucun produit de cette marque n’est actuellement disponible ici.','Impossible de charger l’aperçu. Consultez la marque via « Tous les produits ».','Réessayer','Actuellement épuisé','Produits de'],
    it:['Tutti i prodotti','Caricamento dei prodotti …','Quale marchio cerchi?','Al momento non ci sono prodotti di questo marchio disponibili qui.','Impossibile caricare l’anteprima. Apri il marchio tramite “Tutti i prodotti”.','Riprova','Attualmente esaurito','Prodotti di'],
    es:['Todos los productos','Cargando productos …','¿Qué marca buscas?','No hay productos de esta marca disponibles aquí actualmente.','No se pudo cargar la vista previa. Visita la marca mediante “Todos los productos”.','Reintentar','Actualmente agotado','Productos de'],
    nl:['Alle producten','Producten laden …','Welk merk bedoel je?','Er zijn hier momenteel geen producten van dit merk beschikbaar.','Het voorbeeld kon niet worden geladen. Bekijk het merk via “Alle producten”.','Opnieuw proberen','Momenteel uitverkocht','Producten van'],
    pl:['Wszystkie produkty','Ładowanie produktów …','Którą markę masz na myśli?','Obecnie nie ma tutaj dostępnych produktów tej marki.','Nie udało się załadować podglądu. Zobacz markę przez „Wszystkie produkty”.','Spróbuj ponownie','Obecnie wyprzedane','Produkty marki'],
    fi:['Kaikki tuotteet','Ladataan tuotteita …','Mitä tuotemerkkiä tarkoitat?','Tämän tuotemerkin tuotteita ei ole tällä hetkellä saatavilla täällä.','Esikatselua ei voitu ladata. Tutustu tuotemerkkiin kohdasta ”Kaikki tuotteet”.','Yritä uudelleen','Tällä hetkellä loppuunmyyty','Tuotemerkin tuotteet:'],
    sv:['Alla produkter','Laddar produkter …','Vilket varumärke menar du?','Inga produkter från detta varumärke finns tillgängliga här just nu.','Förhandsvisningen kunde inte laddas. Se varumärket via ”Alla produkter”.','Försök igen','Tillfälligt slutsåld','Produkter från'],
    el:['Όλα τα προϊόντα','Φόρτωση προϊόντων …','Ποια μάρκα εννοείς;','Δεν υπάρχουν προς το παρόν διαθέσιμα προϊόντα αυτής της μάρκας εδώ.','Δεν ήταν δυνατή η φόρτωση της προεπισκόπησης. Δες τη μάρκα μέσω «Όλα τα προϊόντα».','Δοκίμασε ξανά','Προς το παρόν εξαντλημένο','Προϊόντα της']
  };
  const t = copy[(root.dataset.locale || 'en').split('-')[0]] || copy.en;
  const base = new URL(root.dataset.shopRoot || '/',location.origin);
  if (base.origin !== location.origin) return;
  const prefix = base.pathname.replace(/\/?$/,'/');
  const preview = new URLSearchParams(location.search).get('preview_theme_id');
  const preservePreview = url => {
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id',preview);
    return url;
  };
  const vendorURL = brand => {
    const url = new URL(prefix + 'collections/vendors',location.origin);
    url.searchParams.set('q',brand.name);
    return preservePreview(url);
  };
  const matches = (value,intent) => {
    const query = normalize(value), needle = compact(value);
    if (!needle) return [];
    const exact = brands.filter(brand => brand.aliases.some(alias => compact(alias) === needle));
    if (exact.length) return exact;
    if (intent && !['brands','finder'].includes(intent)) return [];
    if (needle.length < 3) return [];
    return brands.filter(brand => brand.aliases.some(alias => compact(alias).startsWith(needle) || (` ${query} `).includes(` ${alias} `)));
  };
  const cache = new Map();
  let revision = 0, timer = null, controller = null;
  const reset = () => {
    revision++;
    clearTimeout(timer);
    controller?.abort();
    controller = null;
    delete results.dataset.brandActive;
  };
  root.addEventListener('monolith:brand-reset',reset);
  const make = (tag,className,text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const productURL = value => {
    try {
      const url = new URL(value,location.origin);
      if (url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)) return preservePreview(url).href;
    } catch (_) {}
    return null;
  };
  const productImage = value => {
    if (!value) return null;
    try {
      const url = new URL(value,location.origin);
      if (url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com')) return url.href;
    } catch (_) {}
    return null;
  };
  function card(item) {
    const link = make('a','mono-advisors__brand-product');
    link.href = item.url; link.target = '_blank'; link.rel = 'noopener';
    if (item.image) {
      const image = make('img'); image.src = item.image; image.alt = ''; image.width = 76; image.height = 76; image.loading = 'lazy';
      link.append(image);
    }
    const info = make('span','mono-advisors__brand-product-info');
    info.append(make('strong','',item.title),make('span','mono-advisors__brand-price',item.price));
    if (!item.available) info.append(make('small','mono-advisors__brand-stock',t[6]));
    link.append(info);
    return link;
  }
  async function loadBrand(brand,container,note,token,force = false) {
    if (token !== revision || !container.isConnected) return;
    container.setAttribute('aria-busy','true');
    note.textContent = t[1];
    const request = new AbortController(); controller = request;
    const timeout = setTimeout(() => request.abort(),12000);
    try {
      let items;
      const cached = cache.get(brand.name);
      if (!force && cached && Date.now() - cached.time < 180000) items = cached.items;
      else {
        let url = vendorURL(brand);
        url.searchParams.set('sort_by','best-selling');
        const found = new Map();
        for (let page = 0; page < 3; page++) {
          url.searchParams.set('section_id','monolith-advisor-products');
          const response = await fetch(url.href,{credentials:'same-origin',signal:request.signal});
          if (!response.ok) throw Error('products');
          const html = new DOMParser().parseFromString(await response.text(),'text/html');
          const data = html.querySelector('[data-advisor-product-results]');
          if (!data) throw Error('products');
          for (const item of data.querySelectorAll('[data-advisor-product-data]')) {
            const vendor = item.querySelector('[data-vendor]')?.textContent?.trim();
            const title = item.querySelector('[data-title]')?.textContent?.trim();
            const href = productURL(item.dataset.url);
            if (normalize(vendor) !== normalize(brand.name) || !title || !href || !/^\d+$/.test(item.dataset.id || '')) continue;
            found.set(item.dataset.id,{title,url:href,price:item.querySelector('[data-money]')?.textContent?.trim() || '',image:productImage(item.querySelector('img')?.getAttribute('src')),available:item.dataset.available === 'true'});
          }
          if (found.size >= 3 || !data.dataset.next) break;
          const next = preservePreview(new URL(data.dataset.next,location.origin));
          if (next.origin !== location.origin || next.pathname !== url.pathname) break;
          next.searchParams.set('q',brand.name); url = next;
        }
        items = [...found.values()].sort((a,b) => Number(b.available) - Number(a.available)).slice(0,3);
        cache.set(brand.name,{items,time:Date.now()});
      }
      if (token !== revision || !container.isConnected) return;
      container.replaceChildren(...items.map(card));
      note.textContent = items.length ? '' : t[3];
    } catch (_) {
      if (token !== revision || !container.isConnected) return;
      note.textContent = t[4];
      const retry = make('button','mono-advisors__color-question',t[5]); retry.type = 'button';
      retry.addEventListener('click',() => { retry.remove(); loadBrand(brand,container,note,token,true); });
      container.replaceChildren(retry);
    } finally {
      clearTimeout(timeout);
      if (token === revision) {
        container.setAttribute('aria-busy','false');
        const browse = container.parentElement?.querySelector('.mono-advisors__brand-all');
        if (browse) browse.hidden = false;
      }
      if (controller === request) controller = null;
    }
  }
  function showBrand(brand,token) {
    results.replaceChildren();
    status.textContent = `${t[7]} ${brand.name}`;
    const group = make('div','mono-advisors__brand-results');
    group.dataset.advisorBrandResults = brand.name;
    const note = make('p','mono-advisors__note',t[1]); note.setAttribute('role','status');
    const list = make('div','mono-advisors__brand-products');
    const all = make('a','mono-advisors__gift-entry mono-advisors__brand-all',t[0] + ' →');
    all.hidden = true;
    all.href = vendorURL(brand).href; all.target = '_blank'; all.rel = 'noopener'; all.setAttribute('aria-label',t[0] + ' – ' + brand.name);
    group.append(note,list,all); results.append(group);
    timer = setTimeout(() => loadBrand(brand,list,note,token),220);
  }
  root.addEventListener('monolith:brand-search',event => {
    const found = matches(event.detail?.value,event.detail?.intent);
    if (!found.length) return;
    event.preventDefault();
    results.dataset.brandActive = 'true';
    const token = revision;
    if (found.length === 1) showBrand(found[0],token);
    else {
      status.textContent = t[2];
      const options = make('div','mono-advisors__brand-choices');
      for (const brand of found) {
        const button = make('button','mono-advisors__color-question',brand.name); button.type = 'button';
        button.addEventListener('click',() => showBrand(brand,token)); options.append(button);
      }
      results.append(options);
    }
  });
  root.dataset.brandCount = String(brands.length);
})();
